/**
 * @author 133987
 */
!function(e){e.fn.fixSelect=function(){return this.each(function(){var n=e(this),t=n.find("option").filter(function(){return"selected"===e(this).attr("selected")}),i=function(){t.length&&t.index()!==n.prop("selectedIndex")&&n.prop("selectedIndex",t.index())};e(window).on("pageshow.fixSelect",function(e){e.originalEvent.persisted&&i()}),i()})}}(jQuery);